// Campus photo for /colleges/university-of-arizona: CC BY-SA 2.0, by Jopxton at English Wikipedia, from
// Wikimedia Commons (https://commons.wikimedia.org/wiki/File%3AOld_Main_(U_of_Arizona).jpg), checked 2026-10-02 by
// scripts/college-photo.mjs (license allowlist, no restrictions, not a logo).
// Resized and self-hosted under public/colleges/university-of-arizona/; credited under the photo.
const photo = {
    "slug": "university-of-arizona",
    "alt": "Old Main, a red brick building with a two-story porch among desert plants at the University of Arizona",
    "src": "/colleges/university-of-arizona/campus-1600.webp",
    "srcSmall": "/colleges/university-of-arizona/campus-800.webp",
    "srcMid": "/colleges/university-of-arizona/campus-1200.webp",
    "width": 1600,
    "height": 900,
    "og": "/colleges/university-of-arizona/og.jpg",
    "title": "Old Main (U of Arizona)",
    "author": "Jopxton at English Wikipedia",
    "license": "CC BY-SA 2.0",
    "licenseUrl": "https://creativecommons.org/licenses/by-sa/2.0",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File%3AOld_Main_(U_of_Arizona).jpg",
    "read": "2026-10-02"
};

export default photo;
